<template>
  <nuxt-link
    :to="link"
    :class="[sizeClass, variantClass]"
    class="group inline-flex items-center justify-center gap-x-2 font-semibold rounded-full transition active:scale-press focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
  >
    {{ label }}

    <icon
      v-if="iconName"
      :name="iconName"
      aria-hidden="true"
      class="size-4 transition group-hover:translate-x-0.5"
    />
  </nuxt-link>
</template>

<script setup lang="ts">
import type { ButtonPrimaryProps } from 'types/button'

const { outline = false, size = 'md', iconName } = defineProps<ButtonPrimaryProps>()

const sizeClass = computed(() => {
  if (size === 'sm') return 'px-4 py-2 text-sm'
  if (size === 'lg') return 'px-7 py-3.5 text-base'
  return 'px-5 py-2.5 text-sm'
})

const variantClass = computed(() => {
  if (outline) {
    return 'text-brand-600 ring-1 ring-inset ring-brand-600 hover:text-brand-700 hover:ring-brand-700 hover:bg-brand-50/70'
  }

  return 'bg-brand-600 text-white shadow-press hover:bg-brand-700'
})
</script>
